/**
 * Devuelve una **función** que devuelve el `path` transformando el `model`.
 * Quita los "[num]" del modelo para limpiarlo como un xPath.
 * No toca a la base.
 *
 * @example getPathFromModelFactory("CAB.LIN[1]")("CAB.LIN[1].TREE[3].HIJO[0]") // -> "CAB.LIN[1].TREE.HIJO"
 *
 * @param {string} base el path del padre, es la base que no se tiene que modificar
 * @return {function}
 */
export function getPathFromModelFactory(base = '') {
  return getPathFromModel;

  /**
   * Devuelve el xPath. Limpia el modelo de los "[num]" para devolverlo como un xPath
   * @example getPathFromModel("CAB.LIN[1].TREE[3].HIJO[0]") // -> "CAB.LIN.TREE.HIJO"
   *
   * @param {string} model el modelo limpiar
   * @return {string}
   */
  function getPathFromModel(model) {
    if (!model.startsWith(base)) {
      throw new Error(`getPathFromModelFactory: el modelo "${model}" no empieza por la base "${base}".`);
    }
    const relativeModel = model.replace(base, '');
    const relativePath = relativeModel.replaceAll(/\[[0-9]*\]/g, '');
    return base + relativePath;
  }
}
